function cov_hp3iluanj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NeighborhoodFilled.tsx";
  var hash = "d3ec55529b362724e5410df33d155ea89d99085f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NeighborhoodFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d3ec55529b362724e5410df33d155ea89d99085f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hp3iluanj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_hp3iluanj();
var Icon = (cov_hp3iluanj().s[0]++, {
  name: 'neighborhood-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM16 10.5603V15C16 15.2761 15.7761 15.5 15.5 15.5H8.5C8.22386 15.5 8 15.2761 8 15V10.5603C8 10.3972 8.07961 10.2443 8.21327 10.1507L11.7133 7.70071C11.8854 7.5802 12.1146 7.5802 12.2867 7.70071L15.7867 10.1507C15.9204 10.2443 16 10.3972 16 10.5603Z\" fill=\"currentColor\"/>"
});
export default Icon;